import { render, staticRenderFns } from "./ModalGerenciarEnvio.vue?vue&type=template&id=5f3a8c5f&scoped=true"
import script from "./ModalGerenciarEnvio.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarEnvio.vue?vue&type=script&lang=js"
import style0 from "./ModalGerenciarEnvio.vue?vue&type=style&index=0&id=5f3a8c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3a8c5f",
  null
  
)

export default component.exports